import { render, staticRenderFns } from "./NsProductDetailCarousel.vue?vue&type=template&id=9bae334c&scoped=true&"
import script from "./NsProductDetailCarousel.vue?vue&type=script&lang=js&"
export * from "./NsProductDetailCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NsProductDetailCarousel.vue?vue&type=style&index=0&id=9bae334c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae334c",
  null
  
)

export default component.exports